import NodeScrollCompressor from './node-scroll-compressor';

export default NodeScrollCompressor;
